import React from 'react'
import styled from 'styled-components'
import UploadButton from './UploadButton'

interface FileUploadProps {
  children: string
  disabled: boolean
  fileName: string
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const FileUpload = (props: FileUploadProps) => {
  return (
    <FileUploadWrapper>
      <UploadButton
        disabled={props.disabled}
        id="file-upload"
        onFileChange={props.onFileChange}
      >
        {props.children}
      </UploadButton>
      <SelectedFile>
        {props.fileName || 'No File Selected'}
        <Spinner visible={props.disabled} />
      </SelectedFile>
    </FileUploadWrapper>
  )
}

const FileUploadWrapper = styled.div`
  display: flex;
  padding: 0.5em 0;
`

const SelectedFile = styled.label`
  border: solid 1px lightgray;
  padding: 0.5rem 1rem 0.4rem;
  margin: 0;
  flex: auto;
  color: dimgrey;
  position: relative;
`

type SpinnerProps = {
  visible?: boolean
}

const Spinner = styled.i.attrs<SpinnerProps>(() => ({
  className: 'fas fa-spinner fa-spin',
}))<SpinnerProps>`
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
  position: absolute;
  top: calc(50% - 7px);
  right: 10px;
`
